<div class="row justify-content-md-center no-gutters">
  <div class="col-12" *ngIf="isRoleIdLoad">
    <div class="row no-gutters">
      <div class="col-12 sessionAudienceSection whiteBg padb0 marL10">
        <div>
          <h5 class="sectionTitleBig">
            Assessment Search<span
              class="searchDrownArrow"
              *ngIf="seaerchAreaDownArrow"
              role="button"
              (click)="searchAreaExpand()"
              (keydown.enter)="searchAreaExpand()"
              ><i class="fa fa-chevron-down"></i></span
            ><span
              class="searchDrownArrow"
              *ngIf="seaerchAreaUpArrow"
              (click)="searchAreaCollapse()"
              (keydown.enter)="searchAreaCollapse()"
              ><i class="fa fa-chevron-up"></i
            ></span>
          </h5>
          <span class="marB10"
            >You will only see results for sessions where you are listed as a coordinator or
            facilitator.</span
          >
          <div *ngIf="searchAreaFields" #searchFieldsHeight>
            <div class="row">
              <div class="col-4">
                <label for="sessionNameorIdInput">Session Name, ID or Display Name</label>
              </div>
              <div class="col-4">
                <label for="companyOrganizationInput">Company/Organization</label>
              </div>
              <div class="col-4 posRelative">
                <div class="nameorEmailorUsername">
                  <label for="nameorEmailorUsernameInput"
                    >First Name Last Name or email address</label
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <div>
                  <input
                    type="text"
                    id="sessionNameorIdInput"
                    [(ngModel)]="sessionNameorId"
                    (input)="onSessionNameorIdChange()"
                    placeholder=""
                    (keyup.enter)="onSearchClick()"
                  />
                  <div *ngIf="showsessionNameorId" class="errorMsgLabelAssessmentSessionName">
                    Please enter at least 3 characters to perform search.
                  </div>
                </div>
              </div>
              <div class="col-4">
                <input
                  type="text"
                  placeholder=""
                  id="companyOrganizationInput"
                  [(ngModel)]="companyOrganization"
                  (ngModelChange)="onCompanyChange()"
                  (keyup.enter)="onFocusOutCompany($event); onSearchClick()"
                  [ngbTypeahead]="searchCompanies"
                  [resultFormatter]="formatMatches"
                  [inputFormatter]="formatMatches"
                  (selectItem)="onCompanySelect($event)"
                  [attr.value]="companyOrganization"
                  (focusout)="onFocusOutCompany($event)"
                />
                <span *ngIf="showCompanyValidation" class="errorMsgLabelAssessmentSessionName">
                  {{ compNameErrorMsg }}
                </span>
              </div>
              <div class="col-4 posRelative">
                <div class="nameorEmailorUsername">
                  <textarea
                    class="assessment-textarea"
                    id="nameorEmailorUsernameInput"
                    (input)="onNameorUserEmailChange()"
                    (keydown)="onNameorUserEmailKeyup($event)"
                    [(ngModel)]="nameorEmailorUsername"
                    placeholder=""
                    (keyup.enter)="onSearchClick()"
                  ></textarea>
                  <div *ngIf="showNameorUserEmailVal" class="errorMsgLabelBottomPos">
                    Please enter at least 3 characters to perform search.
                  </div>
                </div>
                <img
                  src="../../assets/images/infoSmall.png"
                  alt="Search tips"
                  class="assessment-infoIconSmall posAbsolute spacing-info"
                  title="1. For exact search use FN LN &#013;2. For multiple names FN1 LN1;FN2 LN2 &#013;3. For general search either FN LN or email or username"
                />
              </div>
            </div>
            <!--<div class="row">
        <div class="col-4">
            <div> <label>Session Name, ID or Display Name</label><input type="text" [(ngModel)]="sessionNameorId" (input)="onSessionNameorIdChange()" placeholder="" (keyup.enter)="onSearchClick()" /></div>
            <div *ngIf="showsessionNameorId" class="errorMsgLabel">Please enter at least 3 characters to perform search.</div>
        </div>
        <div class="col-4">
            <label>Company/Organization</label>
            <input type="text" placeholder="" [(ngModel)]="companyOrganization" (ngModelChange)="onCompanyChange();this.validateSearch();" (keyup.enter)="onFocusOutCompany($event);onSearchClick()"
                   [ngbTypeahead]="searchCompanies" [resultFormatter]="formatMatches" [inputFormatter]="formatMatches"
                   (selectItem)="onCompanySelect($event)" [attr.value]="companyOrganization"
                   (focusout)="onFocusOutCompany($event)" />
            <span *ngIf="showCompanyValidation" class="errorMsgLabel">
                {{compNameErrorMsg}}
            </span>
        </div>
        <div class="col-4 posRelative">
            <div>
                <label>First Name Last Name or email address or username</label>
                <textarea (input)="onNameorUserEmailChange()" (ngModelChange)="nameorEmailorUsernameChange($event)" (keydown)="onNameorUserEmailKeyup($event)" [(ngModel)]="nameorEmailorUsername" placeholder="" (keyup.enter)="onSearchClick()"></textarea>
                <div *ngIf="showNameorUserEmailVal" class="errorMsgLabelBottomPos">Please enter at least 3 characters to perform search.</div>
            </div>
            <img src="app/bundles/assets/images/infoSmall.png" alt="Search tips" class="assessment-infoIconSmall posAbsolute spacing-info" title="1. For exact search use FN LN &#013;2. For multiple names FN1 LN1;FN2 LN2 &#013;3. For general search either FN LN or email or username" />
        </div>
    </div>-->
            <div class="row">
              <div
                class="col-4"
                *ngIf="
                  userRoleService.roleId === 1 ||
                  userRoleService.roleId === 6 ||
                  userRoleService.roleId === 3
                "
              >
                <label for="subscriptionIdInput">Subscription Id</label>
                <input
                  type="text"
                  id="subscriptionIdInput"
                  [(ngModel)]="subscriptionId"
                  (input)="validateSearch(); setSessionRadioVal()"
                  placeholder=""
                  (keyup.enter)="onSearchClick()"
                  (focusout)="onFocusOutSubscriptionID()"
                />
                <div
                  class="col-12 gutter-space"
                  *ngIf="
                    userRoleService.roleId !== 1 &&
                    userRoleService.roleId !== 6 &&
                    userRoleService.roleId !== 3
                  "
                ></div>
              </div>
              <div class="col-4">
                <label for="select-baseline">Baseline</label>
                <span
                  class="information_icon text-red"
                  *ngIf="assessmentType !== 3 && selectedBaselineId === 'undefined'"
                  >*</span
                >

                <div class="form-group">
                  <select
                    class="form-control custom-select baseline-select"
                    [ngClass]="
                      assessmentType === 3 || selectedBaselineId !== 'undefined'
                        ? ''
                        : 'mandatoryDropdown'
                    "
                    [(ngModel)]="selectedBaselineId"
                    (change)="validateSearch()"
                    id="select-baseline"
                    name="StateID"
                    (keyup.enter)="onSearchClick()"
                  >
                    <!--<option value="undefined">Select Baseline</option>-->
                    <option
                      *ngFor="let item of baselines"
                      value="{{ item.id }}"
                      title="{{ item.description }}"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                  <i class="fa fa-chevron-down"></i>
                </div>
              </div>
              <div class="col-4">
                <div class="rowAddedBorder no-gutters">
                  <div>
                    <input
                      [checked]="assessmentType == 1"
                      type="radio"
                      (click)="onRadioBtnClick('Assessment')"
                      name="assessment"
                      (keyup.enter)="onSearchClick()"
                    />Latest Assessment
                    <img
                      src="../../assets/images/infoSmall.png"
                      alt="The latest assessment associated with the search parameters"
                      class="assessment-infoIconSmall"
                      title="The latest assessment associated with the search parameters"
                    />
                    <!--<i class="fa fa-info-circle"></i>-->
                    <!--<span class="infoIconSmall-secRestrict" title="The latest assessment associated with the search parameters"></span>-->
                    <!--<label>The latest assessment associated with the search parameters</label>-->
                  </div>
                  <div>
                    <input
                      [checked]="assessmentType == 2"
                      type="radio"
                      [disabled]="!showSessionRadioBtn"
                      (click)="onRadioBtnClick('Active_Sessions')"
                      name="assessment"
                      (keyup.enter)="onSearchClick()"
                    />All Session Results
                    <!--<span class="information_icon"><i class="fa fa-info-circle"></i><label>The latest assessments from all active sessions (session date is not passed) associated with the search parameters</label></span>-->
                    <img
                      src="../../assets/images/infoSmall.png"
                      alt="All assessment results associated with a specific session"
                      class="assessment-infoIconSmall"
                      title="All assessment results associated with a specific session"
                    />
                  </div>
                  <div>
                    <input
                      [checked]="assessmentType == 3"
                      type="radio"
                      (click)="onRadioBtnClick('All_Assessments')"
                      name="assessment"
                      (keyup.enter)="onSearchClick()"
                    />All Assessments
                    <!--<span class="information_icon"><i class="fa fa-info-circle"></i><label>All assessments associated with the search parameters</label></span>-->
                    <img
                      src="../../assets/images/infoSmall.png"
                      alt="All assessments associated with the search parameters"
                      class="assessment-infoIconSmall"
                      title="All assessments associated with the search parameters"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-group" id="accordion">
              <div class="panel panel-default">
                <div class="collapse in show">
                  <div class="panel-body">
                    <div class="panel panel-default" id="tab1">
                      <div
                        class="panel-heading advance-search-accordion"
                        role="button"
                        aria-controls="collapse1"
                        (click)="userRoleService.closeAccordion('#collapse1')"
                        (keydown.enter)="userRoleService.closeAccordion('#collapse1')"
                        (keydown.space)="$event.preventDefault(); userRoleService.closeAccordion('#collapse1')"
                      >
                        <h4 class="panel-title" (click)="ScrollIntoView('#tab1')">
                          <a data-bs-parent="#accordion">Advanced Search</a>
                        </h4>
                      </div>
                      <div id="collapse1" class="panel-collapse collapse accordion1">
                        <div class="panel-body">
                          <div id="accordion1" class="col-12 advanced-search">
                            <div class="row">
                              <div class="col-4">
                                <label for="select-locationType">Location Type</label>
                                <div class="form-group">
                                  <select
                                    class="form-control custom-select"
                                    [(ngModel)]="selectedSessionCountryId"
                                    id="select-locationType"
                                    (change)="setSessionRadioVal()"
                                    name="CountryID"
                                    (keyup.enter)="onSearchClick()"
                                  >
                                    <!--<option value='0'>Select</option>-->
                                    <option
                                      *ngFor="let item of sessioncountry"
                                      value="{{ item.id }}"
                                    >
                                      {{ item.name }}
                                    </option>
                                  </select>
                                  <i class="fa fa-chevron-down"></i>
                                </div>
                              </div>
                              <div class="col-4 assessmentCountryLocSuggestList">
                                <label for="countryLocationInput">Country/Location</label>
                                <input
                                  type="text"
                                  id="countryLocationInput"
                                  [(ngModel)]="countryTextbox"
                                  (input)="suggestCountry()"
                                  (blur)="onCountryBlur($event)"
                                  placeholder=""
                                  (keyup.enter)="onSearchClick()"
                                />
                                <ul
                                  class="country_dropdown"
                                  *ngIf="
                                    countrySuggestions.length != undefined &&
                                    countrySuggestions.length >= 1
                                  "
                                >
                                  <li
                                    (mousedown)="countryChange(s.name)"
                                    class="suggestions"
                                    *ngFor="let s of countrySuggestions"
                                  >
                                    {{ s.name }}
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-4">
                                <label for="select-searchByDate">Search by Date</label>
                                <div class="form-group">
                                  <select
                                    class="form-control custom-select"
                                    [(ngModel)]="selectedSearchbyDate"
                                    id="select-searchByDate"
                                    name="SearchbyDate"
                                    (keyup.enter)="onSearchClick()"
                                    (change)="setSessionRadioVal(); enableDateRange($event)"
                                  >
                                    <option value="0">Select</option>
                                    <option *ngFor="let item of searchByDate" value="{{ item.id }}">
                                      {{ item.name }}
                                    </option>
                                  </select>
                                  <i class="fa fa-chevron-down"></i>
                                </div>
                              </div>
                              <div class="col-4 editSessionDate">
                                <label> Date Range </label>
                                <span
                                  id="mandatoryStar"
                                  class="information_icon floatRight mandatoryStar"
                                  *ngIf="selectedSearchbyDate != 0"
                                  >*</span
                                >
                                <div class="row assessmentDateRange">
                                  <div class="form-group col-6">
                                    <div class="input-group">
                                      <input
                                        class="form-control inputValFontSizeLineHeight br0"
                                        placeholder="mm-dd-yyyy"
                                        [(ngModel)]="startDate"
                                        id="startDate"
                                        name="dp"
                                        #dp="ngModel"
                                        (ngModelChange)="
                                          onStartDateSelect($event); onChangeOfInputFields()
                                        "
                                        ngbDatepicker
                                        #d1="ngbDatepicker"
                                        dateFormat="mm-dd-yyyy"
                                        (focusout)="onFocusOutDate()"
                                        [disabled]="disableDateRange"
                                        [ngClass]="
                                          selectedSearchbyDate == 0 ? '' : 'mandatoryDropdown'
                                        "
                                      />
                                      <div class="input-group-append">
                                        <button
                                          class="btn btn-outline-secondary calendar2 br0"
                                          (click)="d1.toggle()"
                                          type="button"
                                          [disabled]="disableDateRange"
                                        >
                                          <i class="fa fa-calendar"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="form-group col-6">
                                    <div class="input-group">
                                      <input
                                        class="form-control inputValFontSizeLineHeight br0"
                                        placeholder="mm-dd-yyyy"
                                        [(ngModel)]="endDate"
                                        id="endDate"
                                        (ngModelChange)="
                                          onEndDateSelect($event); onChangeOfInputFields()
                                        "
                                        name="dp"
                                        ngbDatepicker
                                        #d2="ngbDatepicker"
                                        dateFormat="mm-dd-yyyy"
                                        (focusout)="onFocusOutDate()"
                                        [disabled]="disableDateRange"
                                        [ngClass]="
                                          selectedSearchbyDate == 0 ? '' : 'mandatoryDropdown'
                                        "
                                      />
                                      <div class="input-group-append">
                                        <button
                                          class="btn btn-outline-secondary calendar2 br0"
                                          (click)="d2.toggle()"
                                          type="button"
                                          [disabled]="disableDateRange"
                                        >
                                          <i class="fa fa-calendar"></i>
                                        </button>
                                        <span class="errorMsgLabel toDateErr" *ngIf="IsDateInvalid">
                                          {{ invalidDateErrorMsg }}
                                        </span>
                                        <span
                                          class="errorMsgLabel bothDateError"
                                          *ngIf="showErrorMsgForBothDate"
                                          >{{ dateErrorMsg }}</span
                                        >
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row separateLineTop horizontalLine">
          <div class="col text-right">
            <button
              *ngIf="totalCount == 0 || !seaerchAreaDownArrow"
              type="button"
              (click)="onSearchClick()"
              class="clickBtn"
              [disabled]="!showSearchAndClear"
            >
              Search
            </button>
            <button
              *ngIf="totalCount > 0 && seaerchAreaDownArrow"
              type="button"
              (click)="searchAreaExpand()"
              class="clickBtn"
              [disabled]="!showSearchAndClear"
            >
              Modify Search
            </button>
            <button
              type="reset"
              (click)="onClearClick()"
              class="clickBtn marL20"
              [disabled]="!showSearchAndClear"
            >
              Clear
            </button>
          </div>
        </div>
        <div class="row separateLineTop">
          <div class="col text-left txtLightColor">
            {{ totalCount }} Records
            <div class="row">
              <div class="col text-left">Maximum of 1000 Results will be displayed</div>
            </div>
          </div>
          <div class="col text-right">
            <button
              type="button"
              (click)="onGenerateTeamSnapShotClick()"
              class="clickBtn"
              [disabled]="assessmentIdArray.length === 0"
            >
              Generate Team Snapshot
            </button>
            <button
              type="reset"
              class="clickBtn marL20"
              (click)="onExportClick()"
              [disabled]="!showExportBtn"
            >
              Export Results
            </button>
          </div>
        </div>
        <app-loader-icon *ngIf="showLoaderIcon"></app-loader-icon>
        <div class="separateLineTop searchDataTable assessmentDataTable">
          <!--<input #search class="search" type="text" placeholder="Search..." (keydown.enter)="onSearch(search.value)"
                    (informParentComponent)="parentWillTakeAction($event)"
                                     (editClickEvent)="editClick($event)"
                                     (checkboxChangeEvent)="checkboxClick($event)"
                                     (handlePageChangeEvent)="updateListData($event)"
                    >-->
          <!--<ng2-smart-table [settings]="searchAssessmentDataColumns" [source]="assessmentCriteria"></ng2-smart-table>-->
          <app-smart-data-grid
            *ngIf="showAssessementGrid"
            (selectAllCheckbox)="onSelectAllClick($event)"
            (emitParentPDFClickEvent)="onPdfIconClick($event)"
            (informCheckboxClick)="rowCheckboxClickEvent($event)"
            (informParentComponent)="onNameClick($event)"
            (emitParentEmailClickEvent)="onEmailClick($event)"
            [sampleColumns]="searchAssessmentDataColumns"
            [sampleData]="searchAssessmentData"
            [selectAllChecked]="selectAllChecked"
            [allowCheckbox]="allowRowCheckboxInGrid"
            [iseventRegistered]="iseventRegistered"
            [allowPagination]="allowPagination"
            [isClientSidePagination]="isClientSidePagination"
            [totalRecord]="totalRecord"
            [selectAllCheckboxDisabled]="selectAllCheckboxDisabled"
            [rowCheckboxDisabled]="rowCheckboxDisabled"
            [pageSize]="1000"
          ></app-smart-data-grid>
        </div>

        <div class="popupMaskScreen" *ngIf="showSessionUpdatePopup"></div>
        <div *ngIf="showSessionUpdatePopup" class="showSessionUpdatePopup">
          <h4>Copy Results</h4>
          <div class="row">
            <div class="col-6">
              <p>Name</p>
              <input type="text" autocomplete="off" [(ngModel)]="sessionPopupName" disabled />
            </div>
            <div class="col-6">
              <p>Email</p>
              <input type="text" autocomplete="off" [(ngModel)]="sessionPopupEmail" disabled />
            </div>
            <div class="col-12">
              <h5>From Session</h5>
              <span
                class="closePopUpIcon"
                role="button"
                aria-label="Close copy results"
                (click)="onSessionPopupClose()"
                (keydown.enter)="onSessionPopupClose()"
                (keydown.space)="$event.preventDefault(); onSessionPopupClose()"
                ><i class="fa fa-close"></i
              ></span>
              <p>Name of the session</p>
              <input type="text" autocomplete="off" [(ngModel)]="sessionName" disabled />
            </div>
            <div class="col-12">
              <h5>To Session</h5>
              <p>Name of the session</p>
              <div class="posRelative">
                <input
                  type="text"
                  autocomplete="off"
                  [(ngModel)]="sessionPopupTo"
                  placeholder="Target Session Name"
                  (keyup)="suggestSession()"
                  (blur)="onSessionToBlur()"
                />
                <div *ngIf="showsessionPopupToValidation" class="errorMsgLabel">
                  Please enter at least 3 characters to perform search.
                </div>
              </div>
            </div>
            <div class="col-12 assessmentPopSeggestDrop">
              <ul>
                <li
                  (mousedown)="sessionChange(s.SessionName, s.UniqueID)"
                  *ngFor="let s of sessionSuggestions"
                >
                  {{ s.SessionName }} - {{ s.UniqueID }}
                </li>
              </ul>
            </div>
          </div>

          <div class="row">
            <div class="col text-right">
              <button
                type="button"
                (click)="onSaveCopySession()"
                [ngClass]="showCopySessionSave ? 'clickBtn' : 'clickBtn'"
                [disabled]="!showCopySessionSave"
              >
                Save
              </button>
            </div>
          </div>
        </div>
        <div class="popupMaskScreen" *ngIf="showEmailUpdatePopup"></div>
        <div *ngIf="showEmailUpdatePopup" class="showEmailUpdatePopup">
          <h5>Update Email Address</h5>
          <span
            class="closePopUpIcon"
            role="button"
            aria-label="Close email update"
            (click)="onEmailUpdatePopupClose()"
            (keydown.enter)="onEmailUpdatePopupClose()"
            (keydown.space)="$event.preventDefault(); onEmailUpdatePopupClose()"
            ><i class="fa fa-close"></i
          ></span>

          <div class="row">
            <div class="col-6">
              <p>User Name</p>
              <input type="text" [(ngModel)]="emailPopupName" disabled />
              <p>Old Email</p>
              <input type="text" [(ngModel)]="emailPopupEmail" disabled />
              <div class="posRelative">
                <p>New Email</p>
                <div class="posRelative">
                  <input type="text" [(ngModel)]="emailPopupNewEmail" (input)="emailValidation()" />
                  <div class="errorMsgLabel">{{ emailValidationMsg }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col text-right">
              <button
                type="button"
                (click)="onSaveEmailUpdate()"
                [ngClass]="showEmailUpdateSave ? 'clickBtn' : 'clickBtn'"
                [disabled]="!showEmailUpdateSave"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <ng-template #noticeContent let-modal class="lang-modal">
      <div class="modal-header sm-header">
        <h4 class="titleText">Preferred Language for Team Snapshot</h4>
      </div>
      <div class="modal-body modal-body-med">
        <div class="form-group col-6 langDropdown langInput">
          <select
            class="form-control custom-select"
            id="languagePreferred"
            name="languagePreferred"
            [(ngModel)]="selectedLang"
          >
            <option *ngFor="let item of languageList" value="{{ item.languageAbbrevation }}">
              {{ item.name }}
            </option>
          </select>
          <i class="fa fa-chevron-down"></i>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="clickBtn"
          data-bs-dismiss="modal"
          (click)="clickOK(); modal.dismiss('Cross click')"
        >
          OK
        </button>
      </div>
    </ng-template>

    <ng-template #maxPartcipantNotice let-modal class="lang-modal">
      <div class="modal-header sm-header">
        <h4 class="titleText">Notice</h4>
      </div>
      <div class="modal-body modal-body-med">
        <div class="messageText">
          A maximum of 50 participants can be included in the Team Snapshot. Additionally, manual
          alterations to the snapshot will be required once generated. Refer to the
          <a
            href="https://amedeloitte.sharepoint.com/sites/DOL-c-US-BizChemHub/Nonfacilitator%20Drive/Forms/AllItems.aspx?id=%2Fsites%2FDOL%2Dc%2DUS%2DBizChemHub%2FNonfacilitator%20Drive%2FAdmin%20Portal%20Toolkit%2Fbc%2Dadmin%2Dportal%2Dguide%2Epdf&parent=%2Fsites%2FDOL%2Dc%2DUS%2DBizChemHub%2FNonfacilitator%20Drive%2FAdmin%20Portal%20Toolkit"
            alt="Team Snapshot Generation Guide"
            target="_blank"
            class="modal-text-link"
            >Team Snapshot Generation Guide
          </a>
          found on Deloitte Resources for alteration instructions.
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="clickBtn"
          data-bs-dismiss="modal"
          (click)="modal.dismiss('Cross click')"
        >
          OK
        </button>
      </div>
    </ng-template>
  </div>
</div>
